"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[45605,71073],{

/***/ 271073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DiscountTagColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DiscountTagColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 9.5C21 9.914 20.664 10.25 20.25 10.25C19.395 10.25 18.75 10.895 18.75 11.75C18.75 12.605 19.395 13.25 20.25 13.25C20.664 13.25 21 13.586 21 14V17.75C21 18.164 20.664 18.5 20.25 18.5H3.75C3.336 18.5 3 18.164 3 17.75V14C3 13.586 3.336 13.25 3.75 13.25C4.605 13.25 5.25 12.605 5.25 11.75C5.25 10.895 4.605 10.25 3.75 10.25C3.336 10.25 3 9.914 3 9.5V5.75C3 5.336 3.336 5 3.75 5H20.25C20.664 5 21 5.336 21 5.75V9.5ZM10.5 9.125C10.5 8.504 9.996 8 9.375 8C8.754 8 8.25 8.504 8.25 9.125C8.25 9.746 8.754 10.25 9.375 10.25C9.996 10.25 10.5 9.746 10.5 9.125ZM13.5 14.375C13.5 14.996 14.004 15.5 14.625 15.5C15.246 15.5 15.75 14.996 15.75 14.375C15.75 13.754 15.246 13.25 14.625 13.25C14.004 13.25 13.5 13.754 13.5 14.375ZM9.53026 15.2802C9.23742 15.5731 8.76261 15.5731 8.46976 15.2802C8.17692 14.9874 8.17692 14.5126 8.46976 14.2197L14.4698 8.2197C14.7626 7.92685 15.2374 7.92685 15.5303 8.2197C15.8231 8.51255 15.8231 8.98735 15.5303 9.2802L9.53026 15.2802Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "5",
              x2: "12",
              y2: "18.5",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 136581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ DefaultPromotion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultPromotion = (_a) => {
  var _b = _a, {
    imageUrl,
    title,
    quantity,
    endAt,
    alt,
    isSelected,
    highlightedDescriptions
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "title",
    "quantity",
    "endAt",
    "alt",
    "isSelected",
    "highlightedDescriptions"
  ]);
  return !!title ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    align: "baseline",
    isSelected
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: imageUrl,
    alt,
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionInfo, {
    style: { flex: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title), !!(highlightedDescriptions == null ? void 0 : highlightedDescriptions.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, highlightedDescriptions[0]))) : null;
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected } = _d, props = __objRest(_d, ["theme", "isSelected"]);
  return `${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
  ${isSelected ? `` : `opacity: 0.3;`}
  `;
});
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  padding: 0 0.25rem;
`;
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  font-size: 0.875rem;
  white-space: pre-line;
`;
const PromotionInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  flex: 1;
  margin-left: 1rem;
`;




/***/ }),

/***/ 341291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PromotionOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PromotionOption = (_a) => {
  var _b = _a, {
    promotion,
    isSelected,
    onClick,
    isSelectable
  } = _b, props = __objRest(_b, [
    "promotion",
    "isSelected",
    "onClick",
    "isSelectable"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    isSelected,
    onClick: isSelectable ? onClick : void 0,
    align: "start",
    disabled: !isSelectable
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionIconWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: promotion.imageUrl,
    alt: "icon",
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    direction: "column",
    justify: "space-between",
    style: { flex: 1 },
    height: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: `att-product-detail-selection-promotion-title-${promotion.promotionId}`,
    active: !!isSelected
  }, promotion.title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ConditionText, {
    className: `att-product-detail-selection-promotion-description-${promotion.promotionId}`
  }, promotion.description), !!((_a2 = promotion.highlightedDescriptions) == null ? void 0 : _a2.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, promotion.highlightedDescriptions[0])), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    marginTop: "s8",
    justify: "space-between",
    width: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ExpiredAt, {
    className: `att-product-detail-selection-promotion-ended-at-${promotion.promotionId}`
  }, `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("HSD")}: ${new Date((_b2 = promotion.endedAt) != null ? _b2 : new Date()).toLocaleDateString("vi")}`), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CTA, {
    disabled: !isSelectable
  }, isSelected ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("B\u1ECF ch\u1ECDn") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("\xC1p d\u1EE5ng")))));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected, disabled } = _d, props = __objRest(_d, ["theme", "isSelected", "disabled"]);
  return `
    ${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
    box-sizing: border-box;
    width: 100%;
    display: flex;
    margin-top: 10px;
    padding: 12px;
    border-radius: 8px;
    background-color: ${isSelected ? theme.colors.primary50 : "#ffffff"};
    border: 1px solid ${isSelected ? theme.colors.primary500 : "#E4E5F0"};
    cursor: pointer;
    position: relative;
    overflow: hidden;
   ${disabled ? `&:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         background-color: ${theme.colors.background};
         width: 100%;
         height: 100%;
         top:0;
         left:0;
         opacity: 0.5;
         cursor: not-allowed;
       }` : ``}
  `;
});
const PromotionIconWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])("div")(({ theme }) => `
  min-width:64px;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border-radius: 4px;
  background-color: ${theme.colors.primary100}
`);
const Label = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ active, theme }) => `
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      ${maxLineCss(3)}
      color: ${active ? "#1B1D29" : theme.colors.text};
      white-space: pre-line;
    `);
const maxLineCss = (maxLines) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};
  `;
const ConditionText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.colors.neutral};
    ${maxLineCss(2)}
  `);
const ExpiredAt = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
      font-size: 12px;
      line-height: 16px;
      color: ${theme.colors.neutral};
    `);
const CTA = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme, disabled }) => `
      font-size: 13px;
      line-height: 20px;
      color: ${disabled ? theme.colors.disable : theme.colors.link500};
    `);




/***/ }),

/***/ 583576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(271073);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(628382);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(811495);
/* harmony import */ var modules_cart_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(739069);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  max-height: 600px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








const MAX_DISPLAY_DESCRIPTIONS = 3;
const TierPromotions = (props)=>{
    const { productPromotions , isApplicableWithCombo =true , maxLinesBeforeEllipsis =1 , isCustomerTierPromotions =false ,  } = props;
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { 0: showDetail , 1: setShowDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // all promotions of an item (not being grouped)
    const allItemPromotions = (0,modules_cart_utils__WEBPACK_IMPORTED_MODULE_3__/* .flattenPromotionsFromPromotionGroups */ .Ou)(productPromotions);
    // all tier descriptions of an item (not being grouped)
    const allItemTierDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.tierDescriptions || [], 
            ], []) : [];
        return flattedTierDescriptions.length > 0 ? flattedTierDescriptions.filter((tierDesc)=>!!tierDesc.descriptions.length) : [];
    }, [
        allItemPromotions
    ]);
    const allItemHightLightDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedHightLightDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousHightLightDescriptions, currentPromotion)=>{
            var ref;
            return !!((ref = currentPromotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length) ? [
                ...previousHightLightDescriptions,
                ...currentPromotion.highlightedDescriptions, 
            ] : previousHightLightDescriptions;
        }, []) : [];
        return flattedHightLightDescriptions;
    }, [
        allItemPromotions
    ]);
    const allItemCustomerTierDescription = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedCustomerTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.customerTierDescriptions || [], 
            ], []) : [];
        return flattedCustomerTierDescriptions;
    }, [
        allItemPromotions
    ]);
    // displaying tier descriptions limit to MAX_DISPLAY_DESCRIPTIONS
    const displayTierDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return allItemTierDescriptions.length > MAX_DISPLAY_DESCRIPTIONS ? allItemTierDescriptions.slice(0, MAX_DISPLAY_DESCRIPTIONS) : allItemTierDescriptions;
    }, [
        allItemTierDescriptions
    ]);
    const handleCloseDetailModal = ()=>{
        setShowDetail(false);
    };
    const renderDetailContent = ()=>{
        return allItemTierDescriptions.map((tierDesc, index)=>{
            var ref;
            return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TierDescList, {
                marginBottom: index !== allItemTierDescriptions.length - 1 ? "8px" : "0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: tierDesc.title
                    }),
                    ":",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    tierDesc.descriptions.map((desc, subIndex)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: desc
                        }, "".concat(index, "-").concat(subIndex));
                    })
                ]
            }, index) : null;
        });
    };
    if (!allItemTierDescriptions.length && !isCustomerTierPromotions || isCustomerTierPromotions && !allItemCustomerTierDescription.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!displayTierDescriptions.length || !!allItemCustomerTierDescription.length && isCustomerTierPromotions ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                border: "1px solid #FFEED9",
                borderRadius: "s",
                backgroundColor: "#FFFBF5",
                padding: "s8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        justify: "start",
                        align: "middle",
                        marginBottom: "s4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCol, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .DiscountTagColored */ .G, {
                                    size: 20,
                                    color: "#FFA940"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                    weight: "bold",
                                    color: "#FA8C16",
                                    margin: [
                                        "s0",
                                        "s0",
                                        "s0",
                                        "s4"
                                    ],
                                    children: isCustomerTierPromotions ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ưu đ\xe3i kh\xe1ch h\xe0ng th\xe0nh vi\xean") : (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Mua nhiều th\xeam ưu đ\xe3i")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        paddingLeft: "s8",
                        marginBottom: "s4",
                        justify: "start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                                borderLeft: "2px solid #FFEED9",
                                padding: [
                                    "s0",
                                    "s12"
                                ],
                                children: isCustomerTierPromotions ? allItemCustomerTierDescription.map((tierDesc, index)=>{
                                    return !!tierDesc.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                        weight: "regular",
                                        line: maxLinesBeforeEllipsis,
                                        color: "#FA8C16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledText, {
                                                fontWeight: "bold",
                                                color: "#FA8C16",
                                                children: [
                                                    tierDesc.title,
                                                    ",",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
                                                color: "#FA8C16",
                                                children: tierDesc.description
                                            })
                                        ]
                                    }, index) : null;
                                }) : displayTierDescriptions.map((tierDesc, index)=>{
                                    var ref, ref1;
                                    return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                        weight: "regular",
                                        line: maxLinesBeforeEllipsis,
                                        color: "#FA8C16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledText, {
                                                fontWeight: "bold",
                                                color: "#FA8C16",
                                                children: [
                                                    tierDesc.title,
                                                    ",",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
                                                color: "#FA8C16",
                                                children: (ref1 = tierDesc.descriptions) === null || ref1 === void 0 ? void 0 : ref1.join(" & ")
                                            })
                                        ]
                                    }, index) : null;
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        justify: !isApplicableWithCombo || !!allItemHightLightDescriptions.length ? "space-between" : "end",
                        align: "bottom",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                                children: [
                                    !isApplicableWithCombo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                                        align: "middle",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .InforOutlined */ .l, {
                                                size: 16,
                                                color: "#FAAD14"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                                weight: "regular",
                                                color: "#FAAD14",
                                                margin: [
                                                    "s0",
                                                    "s0",
                                                    "s0",
                                                    "s4"
                                                ],
                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Kh\xf4ng \xe1p dụng c\xf9ng combo")
                                            })
                                        ]
                                    }),
                                    !!allItemHightLightDescriptions.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                                        align: "middle",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .InforOutlined */ .l, {
                                                size: 16,
                                                color: "#FAAD14"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                                weight: "regular",
                                                color: "#FAAD14",
                                                margin: [
                                                    "s0",
                                                    "s0",
                                                    "s0",
                                                    "s4"
                                                ],
                                                children: allItemHightLightDescriptions[0]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isCustomerTierPromotions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDetailButton, {
                                    level: 1,
                                    onClick: ()=>setShowDetail(true),
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem chi tiết")
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            !!showDetail && (!!isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBottomSheet, {
                show: showDetail,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chi tiết khuyến m\xe3i"),
                closeBottomSheet: handleCloseDetailModal,
                backdropClicked: handleCloseDetailModal,
                contentHeight: "500px",
                zIndex: 1060,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                    padding: [
                        "s4",
                        "s16"
                    ],
                    children: renderDetailContent()
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModal, {
                width: 600,
                visible: showDetail,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chi tiết khuyến m\xe3i"),
                centeredTitle: true,
                okText: "",
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Đ\xf3ng"),
                onCancel: handleCloseDetailModal,
                onClose: handleCloseDetailModal,
                showCloseIcon: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModalBody, {
                    children: renderDetailContent()
                })
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TierPromotions);
const StyledDetailButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT)((param)=>{
    let { theme  } = param;
    return "\n  cursor: pointer;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n\n  :hover {\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n  }\n\n  &.is-disabled {\n    opacity: 0.5;\n    cursor: default;\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n  }\n");
});
const StyledModal = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Modal */ .u)(_templateObject());
const StyledModalBody = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .ModalBody */ .f)(_templateObject1());
const TierDescList = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"].ul((param)=>{
    let { marginBottom  } = param;
    return "\n  list-style-position: inside;\n  margin-bottom: ".concat(marginBottom, ";\n");
});
const StyledText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"].span((param)=>{
    let { color , fontWeight , fontSize ="13px" , margin  } = param;
    return "\n  color: ".concat(color, ";\n  font-weight: ").concat(fontWeight, ";\n  font-size: ").concat(fontSize, ";\n  margin: ").concat(margin, "\n");
});
const StyledCol = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX)(_templateObject2());
const StyledBottomSheet = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .BottomSheet */ .R)(_templateObject3());


/***/ }),

/***/ 945605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductPriceAndPromotion": function() { return /* binding */ ProductPriceAndPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(891004);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54230);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(341291);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(136581);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(428247);
/* harmony import */ var _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(414951);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(243290);
/* harmony import */ var components_TierPromotions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(583576);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var helpers_page_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(347822);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var modules_product_detail_shared_ProductReview_StarRating__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(111474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _shared_ProductPriceSkeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(420001);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0.25rem 0;\n  line-height: 23px;\n  max-width: 90%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














const MAX_LINES_BEFORE_ELLIPSIS = 2;
const ProductPriceAndPromotion = ()=>{
    var ref, ref1;
    const { product , price , promotionBlocks , setSelectedPromotion , promotionLoading , minAmountByMonth ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { productRatingData  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { isBot , epicOmni1428 , epicOmni1585 , epicOmni1550  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const showTierPromotionsBlock = !!epicOmni1428 || epicOmni1585;
    const isPromotionDefaultGroupType = (promotions, groupType)=>{
        return groupType ? groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .PromotionGroupType.GROUP_TYPE_DEFAULT */ .VM.GROUP_TYPE_DEFAULT : promotions.every((p)=>!p.isSelectable);
    };
    const newPromotionBlocks = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        // create a promotion with groupType of GROUP_TYPE_TIER_PROMOTIONS
        const tierPromotionBlock = {
            title: "",
            groupType: _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */ .VM.GROUP_TYPE_TIER_PROMOTIONS,
            promotions: promotionBlocks.flatMap((p)=>p.promotions),
            description: ""
        };
        /**  because cart return promotions with groupType in order of Default --> Selectable --> Exclusive
     * we only need to check if default type available or not
     * if yes --> add tier promotions type after default type
     * if no --> add tier promotions to top of the list
     * we also check if there isn't any promotion in the list we return an empty array instead
     */ return !!promotionBlocks.length ? isPromotionDefaultGroupType(promotionBlocks[0].promotions, promotionBlocks[0].groupType) ? [
            promotionBlocks[0],
            tierPromotionBlock,
            ...promotionBlocks.slice(1, promotionBlocks.length), 
        ] : [
            tierPromotionBlock,
            ...promotionBlocks
        ] : [];
    }, [
        promotionBlocks
    ]);
    const mapTierPromotions = (promotions)=>{
        return promotions.map((promotion)=>{
            var ref;
            return {
                cartPromotionId: null,
                promotionId: promotion.promotionId,
                promotionCode: promotion.promotionCode,
                isSelectable: promotion.isSelectable,
                imageUrl: promotion.imageUrl,
                title: promotion.title,
                description: promotion.description,
                endedAt: ((ref = promotion.endedAt) === null || ref === void 0 ? void 0 : ref.toString()) || "",
                name: promotion.name || "",
                tierDescriptions: promotion.tierDescriptions,
                highlightedDescriptions: promotion.highlightedDescriptions,
                customerTierDescriptions: promotion.customerTierDescriptions
            };
        });
    };
    if (!product) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            promotionLoading && !isBot && ((ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_ProductPriceSkeleton__WEBPACK_IMPORTED_MODULE_6__/* .ProductPriceSkeleton */ .J, {
                marginBottom: "s12"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: !!(price === null || price === void 0 ? void 0 : price.finalPrice) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_7__/* .StyledProductPrice */ .bf, {
                            size: "l",
                            discountPercent: price === null || price === void 0 ? void 0 : price.discountPercent,
                            supplierRetailPrice: price.strikeThroughDisplayRowTotal,
                            latestPrice: price.displayRowTotal
                        }),
                        typeof minAmountByMonth === "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                                    weight: "regular",
                                    style: {
                                        display: "inline"
                                    },
                                    marginRight: "s8",
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Gi\xe1 mua trả g\xf3p từ")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .SubTitle */ .DK, {
                                    level: 1,
                                    color: "#F89E33",
                                    style: {
                                        display: "inline"
                                    },
                                    children: "".concat((0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__/* .formatCurrency */ .xG)(minAmountByMonth), "/").concat((0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("th\xe1ng"))
                                })
                            ]
                        })
                    ]
                })
            }),
            epicOmni1550 && !!productRatingData.totalReviews && !!productRatingData.averageRating && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                align: "middle",
                justify: "start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_product_detail_shared_ProductReview_StarRating__WEBPACK_IMPORTED_MODULE_12__/* .StarRating */ .Z, {
                        value: productRatingData.averageRating,
                        starSize: 16
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                        weight: "bold",
                        margin: [
                            "s0",
                            "s4"
                        ],
                        children: productRatingData.averageRating.toFixed(1)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                        weight: "regular",
                        color: "textSecondary",
                        onClick: ()=>(0,helpers_page_actions__WEBPACK_IMPORTED_MODULE_13__/* .scrollSmoothToIdWithOffset */ .A)("review-section"),
                        children: "(".concat(productRatingData.totalReviews, " ").concat((0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("lượt đ\xe1nh gi\xe1"), ")")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__/* .Divider */ .i, {
                dividerStyle: _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.dashed */ .fd.dashed,
                color: "divider"
            }),
            (ref1 = showTierPromotionsBlock ? newPromotionBlocks : promotionBlocks) === null || ref1 === void 0 ? void 0 : ref1.map((param, index)=>{
                let { title , promotions , description , groupType  } = param;
                if (!(promotions === null || promotions === void 0 ? void 0 : promotions.length)) {
                    return;
                }
                const isDefaultGroup = isPromotionDefaultGroupType(promotions, groupType);
                return isDefaultGroup ? // If all `title` fields in the default promotions array of default group type are empty strings, we should hide this block
                promotions.every((promotion)=>!promotion.title) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_7__/* .DefaultPromo */ .hB, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_7__/* .Label */ .__, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    style: {
                                        fontWeight: 500
                                    },
                                    children: title
                                }),
                                !!description ? " (".concat(description, ")") : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .Flex */ .k, {
                            direction: "column",
                            children: promotions.map((promotion, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDefaultPromotion, {
                                    className: "att-product-detail-default-promotion-".concat(promotion.promotionId),
                                    title: promotion.title,
                                    imageUrl: promotion.imageUrl,
                                    endAt: promotion.endedAt ? "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("HSD"), ": ").concat(new Date(promotion.endedAt).toLocaleDateString("vi")) : undefined,
                                    isSelected: promotion.isSelected,
                                    highlightedDescriptions: promotion.highlightedDescriptions
                                }, promotion.promotionId || index);
                            })
                        })
                    ]
                }, index) : groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_5__/* .PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */ .VM.GROUP_TYPE_TIER_PROMOTIONS ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        epicOmni1428 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Shape */ .b, {
                            marginTop: "s16",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TierPromotions__WEBPACK_IMPORTED_MODULE_17__["default"], {
                                productPromotions: [
                                    {
                                        title: "",
                                        groupType: undefined,
                                        promotions: mapTierPromotions(promotions)
                                    }, 
                                ],
                                maxLinesBeforeEllipsis: MAX_LINES_BEFORE_ELLIPSIS
                            })
                        }, index),
                        epicOmni1585 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Shape */ .b, {
                            marginTop: "s16",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_TierPromotions__WEBPACK_IMPORTED_MODULE_17__["default"], {
                                productPromotions: [
                                    {
                                        title: "",
                                        groupType: undefined,
                                        promotions: mapTierPromotions(promotions)
                                    }, 
                                ],
                                isCustomerTierPromotions: true
                            })
                        }, index)
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SelectionPromotionWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_7__/* .Label */ .__, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    style: {
                                        fontWeight: 500
                                    },
                                    children: title
                                }),
                                "".concat(description ? " (".concat(description, ")") : "")
                            ]
                        }),
                        promotions.map((promotion, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_18__/* .PromotionOption */ .M, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_19__/* .getTrackingData */ .O5)({
                                isTrackContent: true,
                                regionName: "optionalPromotion",
                                contentName: promotion.name,
                                target: "productDetail",
                                payload: JSON.stringify({
                                    sku: product.sku,
                                    action: promotion.isSelected ? "unselect" : "select",
                                    promotionID: promotion.promotionId,
                                    screenName: "productDetail",
                                    index
                                })
                            })), {
                                promotion: promotion,
                                onClick: ()=>{
                                    promotion.isSelected ? setSelectedPromotion === null || setSelectedPromotion === void 0 ? void 0 : setSelectedPromotion(undefined) : setSelectedPromotion === null || setSelectedPromotion === void 0 ? void 0 : setSelectedPromotion(promotion);
                                },
                                isSelected: promotion.isSelected && !promotionLoading,
                                isSelectable: promotion.isSelectable && !promotionLoading,
                                className: "att-product-detail-selection-promotion-".concat(promotion.promotionId)
                            }), promotion.promotionId);
                        })
                    ]
                }, index);
            })
        ]
    });
};
const SelectionPromotionWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Shape */ .b)((param)=>{
    let { theme  } = param;
    return "\n  margin-top:".concat(theme.spacing.s16, ";\npadding: ").concat(theme.spacing.s16, ";\nbackground-color: ").concat(theme.colors.background, ";\nborder-radius: ").concat(theme.borderRadius.m, ";\nborder: ").concat(theme.borderWeight.l, " ").concat(theme.colors.border, " solid");
});
const StyledDefaultPromotion = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__/* .DefaultPromotion */ .R)(_templateObject());


/***/ }),

/***/ 420001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ProductPriceSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const ProductPriceSkeleton = (_param)=>{
    var rest = _extends({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, _objectSpreadProps(_objectSpread({}, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
                width: 120,
                height: "1rem",
                marginBottom: "s4",
                marginTop: "s4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
                width: 80,
                height: "1rem"
            })
        ]
    }));
};


/***/ }),

/***/ 606764:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});

exports.Alignment = Alignment;
exports.DSSize = DSSize;
exports.DividerStyleEnum = DividerStyleEnum;
exports.DividerTypeEnum = DividerTypeEnum;
exports.Variant = Variant;
exports.VerticalAlignment = VerticalAlignment;


/***/ }),

/***/ 414951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var _enum = __webpack_require__(606764);



__webpack_unused_export__ = _enum.Alignment;
__webpack_unused_export__ = _enum.DSSize;
exports.fd = _enum.DividerStyleEnum;
__webpack_unused_export__ = _enum.DividerTypeEnum;
__webpack_unused_export__ = _enum.Variant;
__webpack_unused_export__ = _enum.VerticalAlignment;


/***/ })

}]);